<template>
  <div class="jbs-customer-selector">
    <b-overlay :show="loading">
      <div
        class="customer-name text-small mb-1"
        v-show="!loading"
        v-if="isStaff && selected && selected.CardCode"
      >
        {{ selected.CardCode + " (" + selected.CardName + ")" }}
      </div>
      <vue-bootstrap-typeahead
        v-if="isStaff"
        :data="customers"
        v-model="search"
        ref="lookup"
        @blur="showValue = true"
        :serializer="(s) => s.text"
        placeholder="Type a customer name or number..."
        @hit="onInput"
      ></vue-bootstrap-typeahead>
      <b-form-select
        :options="user_customers"
        v-model="user_selected"
        @input="onSelect"
        v-else
      >
      </b-form-select>
    </b-overlay>
  </div>
</template>

<script>
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import jbs_api from "@/modules/jbs-api";
import { debounce, map } from "lodash-es";

export default {
  components: {
    VueBootstrapTypeahead,
  },
  props: {
    value: {
      type: [Object, String, Boolean],
      default: "",
    },
  },
  mounted() {
    this.onValue(this.value);

    if (!this.isStaff) {
      this.user_customers = map(this.$store.state.user.customers, (v, k) => {
        return { value: k, text: v + " (" + k + ")" };
      });
    }
  },
  data() {
    return {
      customers: [],
      user_customers: [],
      search: "",
      selected: "",
      user_selected: "",
      showValue: true,
      loading: false,
    };
  },
  watch: {
    value() {
      this.onValue(this.value);
    },
    search: debounce(function (q) {
      if (!q || !q.trim()) {
        // Field cleared: drop the selection (the customer is optional).
        if (this.selected && this.selected.CardCode) {
          this.selected = "";
          this.$emit("input", "");
        }
        return;
      }
      this.get_customers(q.trim());
    }, 500),
  },
  methods: {
    onValue(val) {
      console.log(val);

      if (!val) {
        return;
      }
      if (typeof val === "object" && val !== null) {
        this.selected = val;
        this.user_selected = val.CardCode;
      } else {
        this.loading = true;
        this.user_selected = val;
        return jbs_api
          .get("CustomerSearch", { params: { q: val } })
          .then((res) => {
            if (res.data.length > 0) {
              this.selected = res.data[0];
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    onInput(val) {
      this.selected = val;
      this.$emit("input", val.value);
    },
    async onSelect(val) {
      if (!val) {
        return;
      }

      var customer_details = await this.resolve_customer(val);

      if (customer_details) {
        this.selected = customer_details;
        this.$emit("input", this.selected);
      }
    },
    resolve_customer(q) {
      this.loading = true;
      return jbs_api.get("CustomerSearch", { params: { q } }).then((res) => {
        this.loading = false;
        if (res.data.length > 0) {
          return res.data[0];
        }

        return false;
      });
    },
    get_customers(q) {
      jbs_api.get("CustomerSearch", { params: { q } }).then((res) => {
        this.customers = map(res.data, (v) => {
          return {
            value: v,
            text: v.CardName + " (" + v.CardCode + ")",
          };
        });

        // A full card code typed in (e.g. C1003697) selects that customer without a click,
        // so the company and contact fields fill in straight away.
        const exact = (res.data || []).find(
          (v) => v.CardCode && v.CardCode.toUpperCase() === q.toUpperCase()
        );
        if (exact && (!this.selected || this.selected.CardCode !== exact.CardCode)) {
          this.onInput({ value: exact });
        }
      });
    },
  },
};
</script>